import { EventContentStatus } from 'globalTypes'

interface Props {
  status: EventContentStatus
}

const StatusLabel = ({ status }: Props) => {
  switch (status) {
    case EventContentStatus.expired:
      return <span className="text-gray-500">Annullato</span>
    case EventContentStatus.in_progress:
      return <span className="text-blue-600">In corso</span>
    case EventContentStatus.past:
      return <span className="text-gray-500">Concluso</span>
    case EventContentStatus.scheduled:
      return <span className="text-brand-main">In programma</span>
  }
}

export default StatusLabel
